/* @ngInject */
function QuoteSectionSnapshotFactory($filter, PricingTableSnapshot) {
  class QuoteSectionSnapshot {
    constructor(data, type, currency, exchangeInfo) {
      this.initDefaultValues(type, currency, exchangeInfo);
      if (data) this.setData(data, currency, exchangeInfo);
    }

    initDefaultValues(type, currency, exchangeInfo) {
      const pricingTableDefault = new PricingTableSnapshot(null, currency, exchangeInfo);

      this.style = {
        backgroundColor: "#FFFFFF00",
        backgroundColorType: "none",
        backgroundImage: null,
        backgroundVideo: null,
        size: "auto",
        header1: {
          font: {},
          size: null,
          color: null,
        },
        header2: {
          font: {},
          size: null,
          color: null,
        },
        text: {
          font: {},
          size: null,
          color: null,
        },
      };
      this.brandCenterSync = true;
      this.sectionType = type || "text";
      this.content = `<h1 placeholder="${$filter("trans")(
        "quoteSectionSnapshot.placeholder.header1",
      )}"></h1><h2 placeholder="${$filter("trans")(
        "quoteSectionSnapshot.placeholder.header2",
      )}"></h2><p placeholder="${$filter("trans")("quoteSectionSnapshot.placeholder.paragraph")}"></p>`;
      if (this.sectionType === "pricingTable") {
        this.pricingTable = pricingTableDefault;
        this.contentBelowPricing = `<p placeholder="${$filter("trans")(
          "quoteSectionSnapshot.placeholder.paragraph.text",
        )}"></p>`;
      }
    }

    setData(data, currency, exchangeInfo) {
      if (!data) return;

      this.style.backgroundColor = data.style.backgroundColor;
      this.style.backgroundColorType = data.style.backgroundColorType;
      this.style.backgroundImage = data.style.backgroundImage;
      this.style.backgroundVideo = data.style.backgroundVideo;
      this.style.size = data.style.size;
      this.sectionType = data.sectionType;
      this.brandCenterSync = data.brandCenterSync;
      this.content = data.content;
      this.style.header1.font = data.style.header1.font || {};
      this.style.header1.size = data.style.header1.size || null;
      this.style.header1.color = data.style.header1.color || null;
      this.style.header2.font = data.style.header2.font || {};
      this.style.header2.size = data.style.header2.size || null;
      this.style.header2.color = data.style.header2.color || null;
      this.style.text.font = data.style.text.font || {};
      this.style.text.size = data.style.text.size || null;
      this.style.text.color = data.style.text.color || null;

      if (this.sectionType === "pricingTable") {
        if (data.pricingTable && this.pricingTable) this.pricingTable.setData(data.pricingTable);
        else this.pricingTable = new PricingTableSnapshot(data.pricingTable, currency, exchangeInfo);

        if (data.contentBelowPricing) this.contentBelowPricing = data.contentBelowPricing;
      }
    }

    hasBackground() {
      return Boolean(
        (this.style.backgroundColorType === "custom" && this.style.backgroundColor.toLowerCase() !== "#ffffff00") ||
          this.style.backgroundColorType !== "none" ||
          this.style.backgroundColor.toLowerCase() !== "#ffffff00" ||
          this.style.backgroundImage ||
          this.style.backgroundVideo,
      );
    }
  }

  return QuoteSectionSnapshot;
}

export default QuoteSectionSnapshotFactory;
